import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgArrowRight = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 13 12"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m9.016 6.265-3.75 3.75a.375.375 0 1 1-.531-.53L8.22 6 4.735 2.515a.375.375 0 1 1 .53-.53l3.75 3.75a.375.375 0 0 1 0 .53"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowRight);
export default ForwardRef;
